export enum SubscriptionBannerType {
  SubscriptionCancelled = "SubscriptionCancelled",
  SubscriptionExpired = "SubscriptionExpired",
  SubscriptionUpcomingRenewal = "SubscriptionUpcomingRenewal",
  PaymentFail = "PaymentFail",
  PaymentPending = "PaymentPending",
  ExpiringCard = "ExpiringCard",
}
